import script from "./MantenimientoView.vue?vue&type=script&setup=true&lang=js"
export * from "./MantenimientoView.vue?vue&type=script&setup=true&lang=js"

import "./MantenimientoView.vue?vue&type=style&index=0&id=de575a04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de575a04"]])

export default __exports__